import React from 'react'
import { Link } from 'gatsby'
import clsx from 'clsx'
import { MdChevronRight } from 'react-icons/md'

const SanityLink = ({ label, page, anchor, external, arrow, className }) => {
	// external page (opens in a new tab)
	if (!!external) return (
		<a className={clsx(className, arrow && 'with-icon')} href={external} target="_blank">
			{label}
			{arrow && <MdChevronRight />}
		</a>
	)

	// internal page (linked to a Sanity page)
	if (!!page?.metaInfo?.slug?.current) {
		const url = `/${ page.metaInfo.slug.current }${ anchor || '' }`

		return (
			<Link className={clsx(className, arrow && 'with-icon')} to={url}>
				{label || page.title}
				{arrow && <MdChevronRight />}
			</Link>
		)
	}

	// document
	if (!!page?.file?.asset.url) return (
		<a className={clsx(className, arrow && 'with-icon')} href={page.file.asset.url} target="_blank">
			{label || page.name}
			{arrow && <MdChevronRight />}
		</a>
	)

	return null
}

export default SanityLink
